import type { ClassValue } from 'clsx';

import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Every theme name outside Tailwind's default scale is registered here, so
// twMerge drops the overridden class instead of keeping both and leaving the
// winner to CSS order, or misreading a size as a colour. lib/utils.spec.ts
// fails when the sheet gains a name this list is missing.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      animate: ['tap-pulse', 'gradient-shimmer', 'loading-colored-dot', 'slideIn', 'fadeOut', 'bounce-select'],
      radius: ['tag', 'card', 'card-lg', 'pill'],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
